import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/** venus toast variants. Typed as string on purpose: juno passes a string enum, which TypeScript will not assign to a literal union. */
export type ToastKind = 'success' | 'error' | 'warning' | 'info';

/**
 * One toast, venus-toast. Drop instances inside <app-toast-container>.
 * Dismiss hides this instance; the owning service still drops it from its list on its own timer.
 */
@Component({
  selector: 'app-toast',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (showsToast) {
      <div class="venus-toast" [class]="'venus-toast venus-toast--' + type()" role="status">
        <div class="venus-toast__content">
          <div class="venus-toast__message">{{ message() }}</div>
        </div>
        <button type="button" class="venus-toast__dismiss" aria-label="Dismiss" (click)="showsToast = false">✕</button>
      </div>
    }
  `,
})
export class ToastComponent {
  readonly message = input('');
  readonly type = input<ToastKind | string>('success');
  showsToast = true;
}

/** Fixed top-right stack the toasts live in. Web toasts are top-right per ux_system_design/CLAUDE.md. */
@Component({
  selector: 'app-toast-container',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'venus-toast-container venus-toast-container--top-right' },
  template: `<ng-content />`,
})
export class ToastContainerComponent {}
